import React, { useRef, useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { EmergencyBar } from "@/components/landing/EmergencyBar";
import { Logo } from "@/components/landing/Logo";
import { useLead } from "@/context/LeadContext";
import { useBooking } from "@/context/BookingContext";

const CATS = [
  { label: "Auto Detailing", to: "/auto-detailing" },
  { label: "Habitat", to: "/nettoyage-habitat" },
  { label: "Immobilier neuf", to: "/entretien-preventif-neuf" },
  { label: "Professionnels", to: "/nettoyage-professionnel" },
  { label: "Réalisations", to: "/realisations" },
  { label: "Urgence 24/48h", to: "/intervention-urgence" },
];

export const Header = () => {
  const { openForm } = useLead();
  const { openBooking } = useBooking();
  const ref = useRef(null);
  const [h, setH] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => {
      setH(el.offsetHeight);
      document.documentElement.style.setProperty("--header-h", `${el.offsetHeight}px`);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("resize", update);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <>
      <div ref={ref} className="fixed top-0 left-0 w-full z-50">
        <div
          className={`overflow-hidden transition-all duration-300 ease-out ${
            scrolled ? "max-h-0 opacity-0" : "max-h-16 opacity-100"
          }`}
        >
          <EmergencyBar />
        </div>

        <header className="w-full bg-white/95 backdrop-blur-xl border-b border-border">
          <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
            <Link to="/" data-testid="logo" className="shrink-0">
              <Logo variant="color" imgClassName="h-11 w-auto" />
            </Link>
            <div className="flex items-center gap-2">
              <button
                data-testid="nav-quote-btn"
                onClick={() => openForm("auto")}
                className="cta hidden sm:inline-flex border border-ink/20 text-ink text-sm font-bold px-4 py-2.5 rounded-sm hover:bg-ink hover:text-white"
              >
                Devis
              </button>
              <button
                data-testid="nav-reserve-btn"
                onClick={openBooking}
                className="cta inline-flex bg-royal text-white text-sm font-extrabold px-5 py-2.5 rounded-sm hover:bg-royal-hover shadow-md shadow-royal/30"
              >
                Réserver
              </button>
            </div>
          </div>
        </header>

        <nav data-testid="category-bar" className="w-full bg-ink text-white border-b border-white/10">
          <div className="max-w-7xl mx-auto px-3 md:px-8">
            <ul className="flex items-center gap-1 sm:gap-2 overflow-x-auto no-scrollbar py-2">
              {CATS.map((c) => (
                <li key={c.to} className="shrink-0">
                  <NavLink
                    to={c.to}
                    data-testid={`cat-${c.to.slice(1)}`}
                    className={({ isActive }) =>
                      `inline-block whitespace-nowrap text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-sm transition-colors ${
                        isActive ? "bg-white/15 text-white" : "text-white/75 hover:text-white hover:bg-white/10"
                      }`
                    }
                  >
                    {c.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
      <div style={{ height: h }} aria-hidden="true" />
    </>
  );
};
